import { useEffect, useState } from 'react';
import { useReducedMotion } from 'framer-motion';

/**
 * Animates a number from 0 to `target` on mount / change. Honours reduced-motion
 * by jumping straight to the target. Returns the rounded current value.
 */
export const useCountUp = (target: number, durationMs = 900): number => {
  const reduce = useReducedMotion();
  const [value, setValue] = useState(reduce ? target : 0);

  useEffect(() => {
    if (reduce || !Number.isFinite(target)) {
      setValue(target);
      return;
    }
    let frame = 0;
    const start = performance.now();
    const from = 0;
    const tick = (now: number) => {
      const t = Math.min(1, (now - start) / durationMs);
      const eased = 1 - Math.pow(1 - t, 3);
      setValue(Math.round(from + (target - from) * eased));
      if (t < 1) frame = requestAnimationFrame(tick);
    };
    frame = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frame);
  }, [target, durationMs, reduce]);

  return value;
};
